module.exports = __webpack_public_path__ + "static/img/image (5).e80a4a72.png";